import { createFeatureSelector, createSelector } from '@ngrx/store';

import { TaskState } from '../models/task-state.interface';

export const selectTaskState = createFeatureSelector<TaskState>('task');

export const selectTasksFilter = createSelector(selectTaskState, state => state.tasksList.filter);

export const selectTasksPageSize = createSelector(selectTaskState, state => state.tasksList.pageSize);
export const selectTasksContinuationToken = createSelector(selectTaskState, state => state.tasksList.continuationToken);
export const selectTasksList = createSelector(selectTaskState, state => state.tasksList.data);
export const selectTasksListLoading = createSelector(selectTaskState, state => state.tasksList.loading);

export const selectCurrentTask = createSelector(selectTaskState, state => state.currentTask.data);
export const selectCurrentTaskLoading = createSelector(selectTaskState, state => state.currentTask.loading);

export const selectNewTasksCount = createSelector(selectTaskState, state => state.newTasksCount);

export const selectSystemUsers = createSelector(selectTaskState, state => state.systemUsers.data);
export const selectSystemUsersLoading = createSelector(selectTaskState, state => state.systemUsers.loading);
